const defaultWidth = 320;
const defaultColors = {
  success: {
    rgb: '87, 204, 149',
    hex: '#57cc95',
  },
  error: {
    rgb: '242, 98, 123',
    hex: '#f2627b',
  },
  warning: {
    rgb: '235, 173, 23',
    hex: '#ebad1a',
  },
  info: {
    rgb: '54, 156, 199',
    hex: '#369cc7',
  },
};
const defaultShadowOpacity = '0.9';

const STYLES = {
  Wrapper: {},
  Containers: {
    DefaultStyle: {
      fontFamily: 'inherit',
      position: 'fixed',
      width: defaultWidth,
      padding: '12px',
      zIndex: 9998,
      WebkitBoxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      boxSizing: 'border-box',
      height: 'auto',
    },

    tl: {
      top: '0px',
      bottom: 'auto',
      left: '0px',
      right: 'auto',
    },

    tr: {
      top: '0px',
      bottom: 'auto',
      left: 'auto',
      right: '0px',
    },

    tc: {
      top: '0px',
      bottom: 'auto',
      margin: '0 auto',
      left: '50%',
      marginLeft: -(defaultWidth / 2),
    },

    bl: {
      top: 'auto',
      bottom: '0px',
      left: '0px',
      right: 'auto',
    },

    br: {
      top: 'auto',
      bottom: '0px',
      left: 'auto',
      right: '0px',
    },

    bc: {
      top: 'auto',
      bottom: '0px',
      margin: '0 auto',
      left: '50%',
      marginLeft: -(defaultWidth / 2),
    },
  },

  NotificationItem: {
    DefaultStyle: {
      position: 'relative',
      width: '100%',
      cursor: 'pointer',
      borderRadius: '2px',
      fontSize: '16px',
      margin: '10px 0 0',
      padding: '12px',
      display: 'block',
      WebkitBoxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      boxSizing: 'border-box',
      opacity: 0,
      transition: '0.3s ease-in-out',
      WebkitTransform: 'translate3d(0, 0, 0)',
      transform: 'translate3d(0, 0, 0)',
      willChange: 'transform, opacity',

      isHidden: {
        opacity: 0,
      },

      isVisible: {
        opacity: 1,
      },
    },

    success: {
      borderTop: `4px solid ${defaultColors.success.hex}`,
      backgroundColor: '#fff',
      color: '#57cc95',
      WebkitBoxShadow: `0 1px 6px 0 #b8b6ca`,
      MozBoxShadow: `0 1px 6px 0 #b8b6ca`,
      boxShadow: `0 1px 6px 0 #b8b6ca`,
    },

    error: {
      borderTop: `4px solid ${defaultColors.error.hex}`,
      backgroundColor: '#fff',
      color: '#f2627b',
      WebkitBoxShadow: `0 1px 6px 0 #b8b6ca`,
      MozBoxShadow: `0 1px 6px 0 #b8b6ca`,
      boxShadow: `0 1px 6px 0 #b8b6ca`,
    },

    warning: {
      borderTop: `4px solid ${defaultColors.warning.hex}`,
      backgroundColor: '#fff',
      color: '#ebad1a',
      WebkitBoxShadow: `0 1px 6px 0 #b8b6ca`,
      MozBoxShadow: `0 1px 6px 0 #b8b6ca`,
      boxShadow: `0 1px 6px 0 #b8b6ca`,
    },

    info: {
      borderTop: `4px solid ${defaultColors.info.hex}`,
      backgroundColor: '#fff',
      color: '#369cc7',
      WebkitBoxShadow: `0 1px 6px 0 #b8b6ca`,
      MozBoxShadow: `0 1px 6px 0 #b8b6ca`,
      boxShadow: `0 1px 6px 0 #b8b6ca`,
    },
  },

  Title: {
    DefaultStyle: {
      fontSize: '16px',
      margin: '0 0 5px 0',
      padding: 0,
      fontWeight: 'normal',
      fontStyle: 'italic',
    },

    success: {
      color: defaultColors.success.hex,
    },

    error: {
      color: defaultColors.error.hex,
    },

    warning: {
      color: defaultColors.warning.hex,
    },

    info: {
      color: defaultColors.info.hex,
    },
  },

  MessageWrapper: {
    DefaultStyle: {
      margin: '0 30px 0 0',
      padding: 0,
    },
  },

  Dismiss: {
    DefaultStyle: {
      cursor: 'pointer',
      fontFamily: 'Arial',
      fontSize: '24px',
      position: 'absolute',
      top: '10px',
      right: '10px',
      lineHeight: '32px',
      backgroundColor: 'transparent',
      color: '#72727e',
      width: '32px',
      height: '32px',
      fontWeight: 'normal',
      textAlign: 'center',
    },
  },

  Action: {
    DefaultStyle: {
      background: '#ffffff',
      borderRadius: '2px',
      padding: '6px 20px',
      fontWeight: 'bold',
      margin: '10px 0 0 0',
      border: 0,
    },

    success: {
      backgroundColor: defaultColors.success.hex,
      color: '#ffffff',
    },

    error: {
      backgroundColor: defaultColors.error.hex,
      color: '#ffffff',
    },

    warning: {
      backgroundColor: defaultColors.warning.hex,
      color: '#ffffff',
    },

    info: {
      backgroundColor: defaultColors.info.hex,
      color: '#ffffff',
    },
  },

  ActionWrapper: {
    DefaultStyle: {
      margin: 0,
      padding: 0,
    },
  },
};

module.exports = STYLES;
